export default __webpack_public_path__ + "static/media/jpeg.a8603fd8.png";